module.exports = __webpack_public_path__ + "static/media/promulgation-landing-download.970c7b61.png";